export const OdinAss = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_7360_41437)">
      <path
        d="M1.59375 6.39844V7.17187L2.80313 7.18125L4.00781 7.19531L4.02188 12.7828L4.03125 18.375H4.80469H5.57813V12V5.625H3.58594H1.59375V6.39844Z"
        fill="#C74343"
      />
      <path
        d="M12.4453 5.73771C11.4609 5.94396 10.8234 6.19708 10.125 6.65646C8.86875 7.48614 7.90313 8.76114 7.52344 10.1018C7.25625 11.0393 7.24219 11.1471 7.24219 12.0002C7.24219 12.8486 7.26094 12.9658 7.51406 13.8752C7.63594 14.3158 7.98281 15.0658 8.25 15.469C9.10313 16.7533 10.4344 17.7424 11.8125 18.1127C12.8391 18.3846 12.5672 18.3752 18.5203 18.3752H24V17.6018V16.833L18.4594 16.8143C12.225 16.7955 12.6563 16.8236 11.7422 16.4346C10.5656 15.9377 9.65156 15.0283 9.15938 13.8518C8.8875 13.2096 8.80313 12.7736 8.80313 12.0002C8.80313 11.2268 8.8875 10.7908 9.15938 10.1486C9.64219 8.99552 10.5516 8.07677 11.6906 7.58458C12.225 7.35021 12.4922 7.27989 13.1109 7.21427C14.2313 7.09708 15.3797 7.38302 16.3078 8.01583C16.7109 8.28771 17.3203 8.90646 17.6063 9.32833C18.0609 10.008 18.3234 10.7627 18.3984 11.6346L18.4313 12.0002H19.2H19.9688V11.7002C19.9688 11.3346 19.8188 10.533 19.6547 10.0174C19.2328 8.68146 18.2484 7.40646 17.0391 6.63302C15.6938 5.77052 13.9313 5.42833 12.4453 5.73771Z"
        fill="#C74343"
      />
      <path
        d="M0 8.8125V9.60937H0.796875H1.59375V13.9922V18.375H2.39063H3.1875V13.1953V8.01562H1.59375H0V8.8125Z"
        fill="#C74343"
      />
      <path
        d="M13.1242 8.84531C12.9602 8.87344 12.5805 8.99531 12.3039 9.10781C11.6945 9.35625 11.0102 10.0219 10.7289 10.6406C10.4992 11.1469 10.4336 11.4516 10.4336 12C10.4336 12.5531 10.4664 12.7172 10.7008 13.2891C10.893 13.7578 11.3195 14.2687 11.7883 14.5922C12.0977 14.8078 12.1914 14.8547 12.6789 15.0422L13.007 15.1641L18.5055 15.1781L23.9992 15.1875V14.3906V13.5937H18.6367C12.468 13.5937 12.9836 13.6312 12.4914 13.1484C12.1305 12.8016 11.9992 12.4922 11.9992 12C11.9992 11.5172 12.1352 11.1984 12.4867 10.8516C12.7023 10.6359 12.8336 10.5469 13.0258 10.4859C13.3398 10.3875 13.8273 10.3828 14.1555 10.4812C14.6289 10.6219 15.1867 11.3062 15.1867 11.7469C15.1867 12 15.1867 12 16.0211 12H16.7945L16.7664 11.6812C16.7289 11.2828 16.4711 10.5797 16.2367 10.2375C15.7586 9.54375 15.0742 9.08437 14.2258 8.88281C13.9633 8.81719 13.3914 8.79844 13.1242 8.84531Z"
        fill="#C74343"
      />
    </g>
    <defs>
      <clipPath id="clip0_7360_41437">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
